module.exports = __webpack_public_path__ + "static/media/arrow-right--black.c42b0805.svg";